(function(root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([''], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(root);
    } else {
        root.InkeSdk = factory(root);
    }
}(window, function() {

    var queryData = (function() {
        var result = {};
        var queryStr = location.href.split('#')[0].split('?')[1];
        if (!queryStr) {
            return null;
        }
        var arr = queryStr.split("&");
        for (var i = 0, len = arr.length; i < len; i++) {
            var item = arr[i].split('='),
                _key = item[0],
                _val = item[1] || '';
            _key && (result[_key] = decodeURIComponent(_val));
        }
        return result;
    })();



    //埋点上报的公共数据
    var reportData = (function(params) {
        var source = "other";
        var ua = navigator.userAgent;
        var os = "other";
        if (/micromessenger/gi.test(ua)) {
            source = "weixin";
        } else if (/mqq/gi.test(ua)) {
            source = "mqq";
        } else if (/weibo/gi.test(ua)) {
            source = "weibo";
        }
        if (/iphone|ipad|ipod/gi.test(ua)) {
            os = "ios";
        } else if (/android/gi.test(ua)) {
            os = "android";
        }
        var query = queryData || {};
        var data = {
            cc: query.origin || query.cc || 'TG6001',
            source: source,
            os: os,
            userid: "0",
            type: "other",
            busi: "apph5",
            page: "",
            url: JSON.stringify(window.location.href),
            info: {}
        };
        return data;
    })();
    //cnzz 埋点数据队列
    var czcData = [];

    function log(msg) {
        console.log(msg);
    }
    /**
     * 动态引入js文件
     * @param {string} url 必须
     * @param {function} callback 可选 
     */
    function loadScript(url, callback) {
        return new Promise(function(resolve, reject) {
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.onreadystatechange = function() {
                if (this.readyState == 'complete') {
                    resolve(true);
                }
            }
            script.onload = function() {
                console.log("load url success");
                resolve(true);
            }
            script.onerror = function() {
                console.log("load url script fail");
                reject(false);
            }
            script.src = (url.indexOf("http") >= 0 ? url : (location.protocol + url));
            head.appendChild(script);
        })

    }


    function extend(obj1, obj2) {
        if (typeof obj1 != "object" || typeof obj2 != "object") {
            return;
        }
        for (var key in obj2) {
            obj1[key] = obj2[key]
        }
        return obj1;
    }


    var InkeSdk = {

        /**
         * 判断是否APP内
         * return 
         */
        isInke: function() {
            return (queryData.uid && queryData.sid);
        },
        /*
         * 客户端H5 页面吊起分享
         {
            "msg": "分享说明",
            "url": "分享地址",
            "title": "分享标题",
            "image": "分享图片地址",// 注意图片地址不能有中文
            "platform": [   // 自由组合，不传值使用默认的（以下全部）
                "qq",       // QQ
                "qzone",    // QQ空间
                "wechat",   // 微信
                "moments",  // 微信朋友圈
                "weibo",    // 微博
                "url"       // 复制链接
            ]
        }
        */
        appShare: function(param) {
            if (!param) {
                return;
            }
            var userAgent = navigator.userAgent;
            var opt = { "action": "shareUrl", data: param };
            if (/iPhone|mac|iPod|iPad/i.test(userAgent) && window.webkit && webkit.messageHandlers) {
                window.webkit.messageHandlers.sendInkeNativeInfo.postMessage(JSON.stringify(opt));
            } else if (/android/i.test(userAgent) && window.InKeJs) {
                window.InKeJs.sendInkeNativeInfo(JSON.stringify(opt));
            } else {
                log("shareUrl_is_fail");
            }
        },
        /**
         * 客户端webview 右上角按钮 控制
         */
        topRightBtn: function() {

        },
        /**
         * 埋点上报
         * @param {object} param 数据                         
                userid: 0,
                type: "",//hactivity hquality haction hview
                busi: "", apph5 share_live act_kpl 。。。
                page: "",index
                url: (window.location.href),
                eid : "",
                info: {}
         * @param {object} conf 配置 
         *      isCnzz: false,//是否需要cnzz 默认false
                isSync: true, //是否异步 默认 ture
         * @param {function} callback 获得结果后的回调函数
         * @returns Promise
         */
        report: function(param, conf, callback) {
            var that = this;
            var opt = reportData;
            var setting = {
                isCnzz: false,
                isSync: true,
            };
            if (typeof param !== "object") {
                console.log("param is error");
                return;
            }
            typeof conf == "function" && (callback = conf);
            opt["time"] = new Date().getTime();
            opt["page"] = "index";
            if (typeof conf == "object") {
                setting = extend(setting, conf);
            }
            opt = extend(opt, param);

            var arr = [];
            for (var index in opt) {
                arr.push(index + "=" + encodeURIComponent(typeof opt[index] == "object" ? JSON.stringify(opt[index]) : opt[index]));
            }

            var url = location.protocol + "//baseapi.busi.inke.cn/b.gif" + "?" + arr.join("&");

            return new Promise(function(resolve, reject) {
                var image = new Image();
                image.src = url;
                if (setting.isSync) {
                    typeof callback == "function" && callback();
                    resolve();
                } else {
                    image.onabort = image.onload = image.onerror = function() {
                        typeof callback == "function" && callback();
                        resolve();
                    };
                }
                if (setting.isCnzz) {
                    that.cnzzLog({
                        category: opt.busi + "_" + opt.cc,
                        action: opt.page || '',
                        label: opt.eid || ''
                    });
                }

            });

        },
        /* CNZZ埋点
         *   Common.log{
         *      action : 'home',
         *       label : "follow_btn"
         *       value : ""
         *     }
         */
        cnzzLog: function(opt) {
            if (!opt || !opt.category || !opt.action || !opt.label) {
                return;
            }
            var category = opt.category,
                nodeid = ''; // 测试用

            if (window._czc) {
                window._czc.push(["_trackEvent", category, opt.action, opt.label, opt.value, nodeid]);
            } else {
                if (!czcData.length) {
                    loadScript("//s95.cnzz.com/z_stat.php?id=1254338501&web_id=1254338501").then(function() {
                        for (var i = 0; i < czcData.length; i++) {
                            window._czc.push(czcData[i]);
                        }
                    }).catch(function(e) {
                        czcData = [];
                        window.console && window.console.log("load cnzz fail");
                    });
                }
                czcData.push(["_trackEvent", category, opt.action, opt.label, opt.value, nodeid]);
            }
        }
    };

    //    exposed public method
    window.InkeSdk = InkeSdk;
    return InkeSdk;
}));